// Configuración de categorías y publicaciones
// Para agregar una nueva categoría, agrégala al array categories
// Para agregar una nueva publicación, agrégala al array correspondiente en su categoría

const publicationCategories = {
  'boletines-pastoral': {
    id: 'boletines-pastoral',
    name: 'Boletines Pastoral',
    description: 'Boletines mensuales de pastoral',
    magazines: [
      {
        id: 'revista1',
        title: 'Revista Actual',
        pdfUrl: '/pdfs/revista1.pdf',
        description: 'Edición más reciente',
        // Campos opcionales para futuras características:
        // date: '2024-12',
        // thumbnail: '/thumbnails/revista1.jpg',
      },
      {
        id: 'revista2',
        title: 'Revista dos',
        pdfUrl: '/pdfs/revista2.pdf',
        description: 'Edición segunda',
        // Campos opcionales para futuras características:
        // date: '2024-12',
        // thumbnail: '/thumbnails/revista2.jpg',
      },
      // Ejemplo de cómo agregar más revistas:
      // {
      //   id: 'revista-nro-3',
      //   title: 'Boletín Pastoral - Noviembre 2024',
      //   pdfUrl: '/pdfs/2024-noviembre.pdf',
      //   description: 'Edición de Noviembre 2024',
      // },
    ]
  },
  'documentos-institucionales': {
    id: 'documentos-institucionales',
    name: 'Documentos Institucionales',
    description: 'Documentos oficiales y normativos de la institución',
    magazines: [
      {
        id: 'manual-convivencia',
        title: 'Manual de Convivencia',
        pdfUrl: '/pdfs/manual-convivencia-2026.pdf',
        description: 'Manual de convivencia institucional',
        // date: '2025',
      },
      {
        id: 'proyecto-inclusion',
        title: 'Proyecto de Inclusión',
        pdfUrl: '/pdfs/proyecto-inclusion-lsyh-2026.pdf',
        description: 'Proyecto de inclusión educativa',
        // date: '2025',
      },
      {
        id: 'sistema-evaluacion',
        title: 'Sistema Institucional de Evaluación',
        pdfUrl: '/pdfs/siee-2026.pdf',
        description: 'Sistema institucional de evaluación de los estudiantes',
        // date: '2025',
      },
      {
        id: 'textos-utiles-escolares',
        title: 'Lista de Textos y Útiles Escolares',
        pdfUrl: '/pdfs/lista-textos-utiles-escolares-2026.pdf',
        description: 'Lista de textos y útiles escolares requeridos',
        // date: '2025',
      },
      // Puedes agregar más documentos institucionales aquí siguiendo el mismo formato
    ]
  },
  // Para agregar una nueva categoría, copia este ejemplo y personalízalo:
  // 'nombre-categoria': {
  //   id: 'nombre-categoria',  // Mismo que la clave, se usará en la URL
  //   name: 'Nombre Visible de la Categoría',
  //   description: 'Descripción breve de esta categoría',
  //   magazines: [
  //     {
  //       id: 'nombre-documento',  // Se usará en la URL
  //       title: 'Título del Documento',
  //       pdfUrl: '/pdfs/archivo.pdf',  // Ruta al PDF en public/pdfs/
  //       description: 'Descripción del documento',
  //     }
  //   ]
  // },
};

// Función para obtener todas las categorías
export const getAllCategories = () => {
  return Object.values(publicationCategories);
};

// Función para obtener una categoría por ID
export const getCategoryById = (categoryId) => {
  return publicationCategories[categoryId] || null;
};

// Función para obtener una revista por ID de categoría y revista
export const getMagazineById = (categoryId, magazineId) => {
  const category = publicationCategories[categoryId];
  if (!category) return null;
  return category.magazines.find(mag => mag.id === magazineId) || null;
};

// Función para obtener todas las revistas de una categoría
export const getMagazinesByCategory = (categoryId) => {
  const category = publicationCategories[categoryId];
  return category ? category.magazines : [];
};

// Función para obtener todas las revistas (para compatibilidad)
export const getAllMagazines = () => {
  return Object.values(publicationCategories).flatMap(cat => 
    cat.magazines.map(mag => ({ ...mag, category: cat.id, categoryName: cat.name }))
  );
};

// ID por defecto (primera categoría y primera revista)
export const getDefaultMagazineId = () => {
  const categories = Object.values(publicationCategories);
  if (categories.length > 0 && categories[0].magazines.length > 0) {
    return {
      categoryId: categories[0].id,
      magazineId: categories[0].magazines[0].id
    };
  }
  return null;
};

export default publicationCategories;
